import { render, staticRenderFns } from "./ContentCollectionsModal.vue?vue&type=template&id=3ad8ccf4&lang=pug&"
import script from "./ContentCollectionsModal.vue?vue&type=script&lang=js&"
export * from "./ContentCollectionsModal.vue?vue&type=script&lang=js&"
import style0 from "./ContentCollectionsModal.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports